import React from "react";

const TripDetail = () => {
  return (
    <section className="checkout-trip-detail">
      <div className="detail-wrap row">
        <div className="value col-md-6">
          Kms limit : <span>301 Kms</span>
        </div>
        <div className="value col-md-6">
          Fuel : <span>Excluded</span>
        </div>
        <div className="value col-md-6">
          Extra kms charge :  <span>₹ 13/km</span>
        </div>
        <div className="value col-md-6">
          Tolls: <span>To be paid by you</span>
        </div>
      </div>
    </section>
  );
};

export default TripDetail;
